<nz-row style="padding: 5px 5px 10px 5px;" *ngIf="!loading">
  <nz-col [nzSpan]="24" [ngClass]="isConsolePage ? 'console' : 'standalone'">
    <nz-card nzBordered [nzTitle]="nzTitle" class="project-card shadow">
      <ng-template #nzTitle>
        <div class="project-card-header">
          <div class="project-title-wrap">
            <nz-avatar nzIcon="project" style="margin-right:10px" [nzSrc]="getIcon(projectData?.name)"></nz-avatar>
            <h1 class="heading-text"> <strong>{{projectData?.name}}</strong></h1>
            <nz-tag nzColor="geekblue" class="event-count-badge" 
              nz-tooltip 
              [nzTooltipTitle]="eventTooltip"
              nzTooltipPlacement="bottom">
              Events: {{ projectData?.total_events_created ?? 0 }}/{{ projectData?.total_events ?? 0 }}
            </nz-tag>
            <ng-template #eventTooltip>
              <div style="font-size: 12px; max-width: 200px;">
                <p style="margin: 0 0 4px 0;"><strong>Events Created / Total Events</strong></p>
                <p style="margin: 0;">{{ projectData?.total_events_created ?? 0 }} {{ (projectData?.total_events_created ?? 0) === 1 ? 'event' : 'events' }} created out of {{ projectData?.total_events ?? 0 }} total {{ projectData?.total_events === 1 ? 'event' : 'events' }} planned for this project.</p>
              </div>
            </ng-template>
          </div>
          <div class="project-actions-wrap">
            <div class="project-region" *ngIf="regionData">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                </path>
              </svg>
              <span style="font-weight: 500;">{{regionData?.region}}</span>
            </div>
            <button nz-button (click)="createEvent('event')" class="project-action-button">
              <nz-icon nzType="plus" nzTheme="outline" /> Event
            </button>
            <button nz-button (click)="createTask('task')" class="project-action-button">
              <nz-icon nzType="plus" nzTheme="outline" /> Task
            </button>

            <button nz-button nzType="default" class="project-action-button" (click)="editProject(projectData)">
              <nz-icon nzType="edit" nzTheme="fill" />
            </button>
            <button class="custom-popconfirm project-action-button" nz-popconfirm [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
              [nzPopconfirmTitle]="popconfirmTpl" nzPopconfirmPlacement="bottom" nz-button nzDanger
              (nzOnConfirm)="deleteProject(projectData)">
              <nz-icon nzType="delete" nzTheme="fill" />
            </button>


          </div>
        </div>

      </ng-template>
      <nz-descriptions nzBordered>

        <ng-template #idTitle>
          <h4 style="width:120px"><i nz-icon nzType="idcard"></i> Project ID</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="idTitle">
          <nz-tag> {{ formatIdToFourDigits(projectData?.id , 'PR') }}</nz-tag>
        </nz-descriptions-item>

        <ng-template #clientTitle>
          <h4><i nz-icon nzType="apartment"></i> Client</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="clientTitle">
          <a target="_blank" [href]="'/app/clients/' + projectData?.project_client"> {{projectData?.client_name}} </a>
        </nz-descriptions-item>

        <ng-template #dueDateTitle>
          <h4 style="width:120px"><i nz-icon nzType="clock-circle"></i> Due Date</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="dueDateTitle">
          {{projectData?.due_date}}
        </nz-descriptions-item>


        <!-- <ng-template #userTitle>
          <h4><i nz-icon nzType="user"></i> Client POC</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="userTitle" style="width:180px;display:flex;flex-wrap: wrap;">
          <ul style="padding: 0px;width:210px;">
            <li style="list-style-type: none;display:inline-block" *ngFor="let poc of clientData?.poc_details">
              <nz-tag nzColor="success" (click)="showModal()" style="cursor: pointer">
            <nz-icon nzType="user" /> {{ poc?.poc_name }} </nz-tag> </li>
          </ul>

        </nz-descriptions-item> -->
        <ng-template #csm>
          <h4><i nz-icon nzType="user-switch"></i> CSM</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="csm">

          <nz-avatar nzSize="small" *ngIf="projectData?.customer_success_manager_name"
            [nzText]="projectData?.customer_success_manager_name?.charAt(0).toUpperCase()"
            [nzSrc]="getBase64Image(projectData?.customer_success_manager_image)" nz-tooltip
            [nzTooltipTitle]="titleTemplate" nzTooltipPlacement="top" style="margin-right: 5px;"></nz-avatar>

          <ng-template #titleTemplate let-thing>
            <ul style="padding: 10px 20px;margin:0px;font-size: 11px;">
              <li *ngIf="projectData?.customer_success_manager_name">{{projectData?.customer_success_manager_name}}</li>
              <li *ngIf="projectData?.customer_success_manager_email">{{projectData?.customer_success_manager_email}}
              </li>
              <li *ngIf="projectData?.customer_success_manager_phone.phone_number != null">
                {{projectData?.customer_success_manager_phone?.country_code}}
                {{projectData?.customer_success_manager_phone?.phone_number}}

              </li>
            </ul>
          </ng-template>
        </nz-descriptions-item>


        <ng-template #asignToTitle>
          <h4><i nz-icon nzType="user-switch"></i> Assigned To</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="asignToTitle">

          <nz-avatar *ngFor="let user of projectData?.assign_to_detail, let i = index" nzSize="small"
            [nzText]="user.name[0].toUpperCase()" [nzSrc]="getBase64Image(user.image)" nz-tooltip
            [nzTooltipTitle]="user.name" nzTooltipPlacement="top" style="margin-right: 5px;"></nz-avatar>


        </nz-descriptions-item>


        <ng-template #asignToGrpTitle>
          <h4 style="width:160px"><i nz-icon nzType="usergroup-add"></i> Assigned To Groups</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="asignToGrpTitle">
          <nz-tag [nzColor]="'purple'" *ngFor="let group of getAssignedToGroupInList(
           projectData?.assigned_to_group_name) " [nzBordered]="false"> {{ group }} </nz-tag>
        </nz-descriptions-item>


        <ng-template #projecttype>
          <h4><i nz-icon nzType="user-switch"></i> Project Type</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="projecttype">

          <nz-tag [nzColor]="'purple'"> {{ getProjectTypeWithFormatLabel() }}</nz-tag>

        </nz-descriptions-item>


        <ng-template #statusTitle>
          <h4><i nz-icon nzType="rise"></i> Status</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="statusTitle">
          <nz-badge [nzStatus]="'processing'" style="width:140px"
            *ngIf="projectData?.status_name != null &&projectData?.status_name.length > 1"
            [nzText]="projectData?.status_name"></nz-badge> <br />
          <span style="font-size:10px;font-style: italic;" *ngIf="projectData?.status_name == 'Cancelled'">
            {{projectData?.cancelled_reason_name}} -
            {{ projectData?.cancelled_closed_reason_str?.length < 30 ? projectData?.cancelled_closed_reason_str :
              projectData?.cancelled_closed_reason_str.slice(0,30) + '...' }} </span>
              <span style="font-size:10px;font-style: italic;" *ngIf="projectData?.status_name == 'Closed'">
                {{projectData?.closed_reason_name}} -
                {{ projectData?.cancelled_closed_reason_str?.length < 30 ? projectData?.cancelled_closed_reason_str :
                  projectData?.cancelled_closed_reason_str.slice(0,30) + '...' }} </span>
        </nz-descriptions-item>

        <ng-template #planTitle>
          <h4><i nz-icon nzType="retweet"></i> Project Plan</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="planTitle">
          @if(projectData?.project_plan){
          <button nz-button [nzSize]="'small'" nzType="default"
            (click)="openProjectPlan(projectData?.project_plan)">Open Project Plan</button>
          } @else{
          <button nz-button [nzSize]="'small'" nzType="default"
            (click)="CreateProjectPlanModal(projectData?.id, projectData?.name)">Create Project Plan</button>
          }

        </nz-descriptions-item>


        <!-- <ng-template #contractTitle>
          <h4><i nz-icon nzType="file"></i> Contracts</h4>
        </ng-template>
        <nz-descriptions-item [nzTitle]="contractTitle">
          <div style="margin-top: 10px" *ngIf="projectData?.contract_file_details?.length > 0">
            <span style="margin-bottom: 0;" *ngFor="let contract of projectData?.contract_file_details ; let i = index">
              <a [href]="contract.file" target="_blank"> {{contract?.name}}</a> <span
                *ngIf="projectData?.contract_file_details?.length - 1  > i"> ,</span>
            </span>
          </div>
          <div>

          </div>
        </nz-descriptions-item> -->
      </nz-descriptions>


    </nz-card>
  </nz-col>
</nz-row>


<nz-row style="padding: 5px 5px 10px 5px;" *ngIf="!loading">
  <nz-col [nzSpan]="24" [ngClass]="isConsolePage ? 'console' : 'standalone'">
    <nz-tabset [nzSize]="'small'" (nzSelectedIndexChange)="onTabChange($event)" nzType="card"
      [(nzSelectedIndex)]="selectedTabIndex" nzDestroyInactiveTabPane="true">
      <nz-tab [nzTitle]="nzTitleTasks">
        <ng-template #nzTitleTasks>
          <i nz-icon nzType="reconciliation"></i> Tasks
        </ng-template>


        <nz-table #virtualTableTS [nzBordered]="false" [nzVirtualItemSize]="40" [nzVirtualForTrackBy]="trackByIndex"
          [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ x: '1000px', y: '200px' }"
          [nzSize]="'small'" [nzData]="listOfTasks" class="table-shadow">
          <thead>
            <tr>
              <th nzWidth="10%">ID</th>
              <th nzWidth="30%">Task</th>
              <!-- <th nzWidth="20%">Project</th> -->
              <th nzWidth="15%">Priority</th>
              <th nzWidth="15%">Due Date</th>
              <th nzWidth="15%">Status</th>
            </tr>
          </thead>
          <tbody>
            <ng-template nz-virtual-scroll let-task let-index="index">
              <tr>
                <td> <nz-tag> {{ formatIdToFourDigits(task.id , 'TS') }} </nz-tag></td>
                <td style="font-weight: bold;"><a (click)="goToDetail(task)">{{ task.name }}</a></td>
                <!-- <td>{{ task.project_name }}</td> -->
                <td>
                  <nz-tag [nzColor]="getPriorityColor(getTaskPriorityName(task?.priority))">{{
                    getTaskPriorityName(task?.priority) }}</nz-tag>
                </td>
                <td>{{ task.due_date | date:'yyyy-MM-dd' }}</td>
                <td>
                  <nz-tag [nzColor]="getStatusColor(task.task_status)">{{ task?.task_status_name }}</nz-tag>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
        <div class="pagination-load-more" *ngIf="loadingMore">
          <nz-spin nzSimple nzSize="small"></nz-spin>
          <span>Loading more…</span>
        </div>



      </nz-tab>
      <nz-tab [nzTitle]="nzTitleComments">
        <ng-template #nzTitleComments>
          <i nz-icon nzType="comment"></i> Work Notes
        </ng-template>

        <app-cpd-overview *ngIf="selectedTabIndex == 1" [UIType]="false" [desc]="projectData?.description"
          [projectId]="tabData?.id"></app-cpd-overview>

      </nz-tab>
      <nz-tab [nzTitle]="nzTitleHistory">
        <ng-template #nzTitleHistory>
          <i nz-icon nzType="audit"></i> History
        </ng-template>

        <app-cpd-history *ngIf="selectedTabIndex == 2" [projectId]="tabData?.id"
          [activetab]="selectedTabIndex"></app-cpd-history>
      </nz-tab>
      <nz-tab [nzTitle]="nzTitlePeople">
        <ng-template #nzTitlePeople>
          <i nz-icon nzType="usergroup-add"></i> People
        </ng-template>


        <app-cpd-people *ngIf="selectedTabIndex == 3" [project_client]="projectData?.project_client"
          (pocCreated)="onPocCreated($event)"></app-cpd-people>
      </nz-tab>
      <nz-tab [nzTitle]="nzTitleFiles">
        <ng-template #nzTitleFiles>
          <i nz-icon nzType="file-done"></i> Files
        </ng-template>



        <app-cpd-files *ngIf="selectedTabIndex == 4" [data]="projectData"
          (filesChanged)="onFilesChanged($event)"></app-cpd-files>
      </nz-tab>
      <nz-tab [nzTitle]="nzTitleLinks">
        <ng-template #nzTitleLinks>
          <i nz-icon nzType="link"></i> Links
        </ng-template>


        <app-cpd-drive-links *ngIf="selectedTabIndex == 5" [projectLinks]="projectData?.link_details"
          [project]="projectData" (linksChanged)="onLinksChanged($event)"></app-cpd-drive-links>

      </nz-tab>

      <nz-tab [nzTitle]="nzTitleEvents">
        <ng-template #nzTitleEvents>
          <i nz-icon nzType="calendar"></i> Events
        </ng-template>

        <app-cpd-events *ngIf="selectedTabIndex == 6" [project_id]="projectData?.id"></app-cpd-events>
      </nz-tab>


    </nz-tabset>



  </nz-col>
</nz-row>


<app-loader *ngIf="loading"></app-loader>

<app-project-plan-drawer [isVisible]="showProjectPlanDrawer"
  (closeDrawer)="closeProjectPlanDrawer()"></app-project-plan-drawer>

<nz-modal [(nzVisible)]="showHistory" nzTitle="Project History" [nzWidth]="900" (nzOnCancel)="setIsVisible()"
  [nzFooter]="modalFooter">
  <ng-container *nzModalContent>
    <app-cpd-history [projectId]="projectData?.id"></app-cpd-history>
  </ng-container>
  <ng-template #modalFooter>
    <button nz-button nzType="primary" (click)="setIsVisible()">OK</button>
  </ng-template>
</nz-modal>

<app-client-poc-detail [isVisible]="isVisible" [poc_details]="clientData?.poc_details" [showActions]="false"
  (closePoc)="handleCancel()"></app-client-poc-detail>



<app-console-project-detail [isVisible]="showProjectDetail" [tabData]="selectData" [type]="selectedType"
  (closeModal)="closeProjectDetail()"></app-console-project-detail>




<ng-template #popconfirmTpl let-popconfirm="popconfirm">
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">Confirm Deletion</span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this item?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
  <!-- <div class="custom-popconfirm-footer" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
    <button nz-button nzType="default" class="custom-delete-modal__cancel" (click)="$event.stopPropagation(); popconfirm?.nzCancel.emit()">Cancel</button>
    <button nz-button nzType="primary" nzDanger class="custom-delete-modal__ok" (click)="$event.stopPropagation(); popconfirm?.nzConfirm.emit()">
      <nz-icon nzType="delete" nzTheme="outline" style="margin-right: 4px;"></nz-icon>OK
    </button>
  </div> -->
</ng-template>